import { APP_CONFIG } from '../base';

export { redirectToMenu, redirectToCart, isMenu, isCart, isOrderStatus };

const redirectToMenu = () => {
    window.location.href = APP_CONFIG.navigation.menu;
};

const redirectToCart = () => {
    window.location.href = APP_CONFIG.navigation.cart;
};

// If menu btn is in HTML we know that this is for sure menu template
const cartIcon = document.querySelector('[data-js=appnavbtn]');
// Function in here is in case checks should be more advanced in the future
const isMenu = () => (cartIcon ? true : false);

// Flag for cart template
const isCart = () => window.location.pathname === APP_CONFIG.navigation.cart;

// Flag for order status template
const isOrderStatus = () => window.location.pathname === APP_CONFIG.navigation.orderstatus;
